var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngenieringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.91,
    height: 18,
    viewBox: "0 0 21.91 18",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5772",
    "data-name": "Group 5772",
    transform: "translate(-1 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5773",
    "data-name": "Group 5773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8166",
    "data-name": "Path 8166",
    d: "M9,15c-2.67,0-8,1.34-8,4v1a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V19C17,16.34,11.67,15,9,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8167",
    "data-name": "Path 8167",
    d: "M4.74,9h8.53a.491.491,0,0,0,.49-.49V8.49A.491.491,0,0,0,13.27,8H13a4,4,0,0,0-2-3.45V5.5a.5.5,0,0,1-1,0V4.14A4.091,4.091,0,0,0,9,4a4.091,4.091,0,0,0-1,.14V5.5a.5.5,0,0,1-1,0V4.55A4,4,0,0,0,5,8H4.74a.491.491,0,0,0-.49.49v.03A.489.489,0,0,0,4.74,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8168",
    "data-name": "Path 8168",
    d: "M9,13a4,4,0,0,0,3.86-3H5.14A4,4,0,0,0,9,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8169",
    "data-name": "Path 8169",
    d: "M21.98,6.23l.93-.83-.75-1.3-1.19.39a1.982,1.982,0,0,0-.47-.27L20.25,3h-1.5L18.5,4.22a2.272,2.272,0,0,0-.48.27L16.84,4.1l-.75,1.3.93.83a2.261,2.261,0,0,0,0,.52l-.93.85.75,1.3,1.2-.38a2.3,2.3,0,0,0,.43.25L18.75,10h1.5l.27-1.22a2.38,2.38,0,0,0,.44-.25l1.19.38.75-1.3-.93-.85A2.37,2.37,0,0,0,21.98,6.23ZM19.5,7.75A1.25,1.25,0,1,1,20.75,6.5,1.25,1.25,0,0,1,19.5,7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8170",
    "data-name": "Path 8170",
    d: "M19.4,10.79l-.85.28a1.35,1.35,0,0,0-.33-.19L18.04,10H16.97l-.18.87a1.863,1.863,0,0,0-.34.19l-.84-.28-.54.93.66.59a2.284,2.284,0,0,0,0,.37l-.66.61.54.93.86-.27a1.924,1.924,0,0,0,.31.18l.18.88h1.07l.19-.87a2.016,2.016,0,0,0,.32-.18l.85.27.54-.93-.66-.61a2.284,2.284,0,0,0,0-.37l.66-.59Zm-1.9,2.6a.89.89,0,1,1,.89-.89A.892.892,0,0,1,17.5,13.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngenieringIcon);
export default __webpack_public_path__ + "static/media/engeniering_icon.956d59710e4e9b88e8d63d5020b2d865.svg";
export { ForwardRef as ReactComponent };